export function monthlyCostCenterTotal(amountsByMonth, month) {
  const monthAmounts = amountsByMonth?.[String(month)] ?? amountsByMonth?.[month];
  if (!monthAmounts || typeof monthAmounts !== "object" || Array.isArray(monthAmounts)) return null;
  const values = Object.values(monthAmounts).map(Number).filter(Number.isFinite);
  return values.length ? values.reduce((total, amount) => total + amount, 0) : null;
}

export function monthlyBillingDisplayValue({ amountsByMonth, month, previousValue, fallbackValue }) {
  const allocatedTotal = monthlyCostCenterTotal(amountsByMonth, month);
  if (allocatedTotal !== null) return String(allocatedTotal);
  return previousValue || fallbackValue || "0";
}

export function percentToFraction(value, label) {
  const text = String(value ?? "").trim().replace(",", ".");
  const percent = Number(text);
  if (!Number.isFinite(percent) || percent < 0 || percent > 100) {
    throw new Error(`${label} указывается числом от 0 до 100%.`);
  }
  return percent / 100;
}

export function fractionToPercentLabel(value) {
  const fraction = Number(value);
  if (!Number.isFinite(fraction)) return "";
  return String(Number((fraction * 100).toFixed(4)));
}

export function totalMonthlyBilling(values) {
  return Array.from(values || []).reduce((total, value) => {
    const amount = Number(String(value ?? "").trim() || 0);
    return total + (Number.isFinite(amount) ? amount : 0);
  }, 0);
}
